// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3s3qb","list":"PatternAutocomplete_list__FX3cI"};